<template>
    <div class="m-head">

        <h1 class="logo"><a href="https://www.m3guo.com/v2/" target="_blank"></a></h1>
        <div class="u-web web-huya"><a href="https://www.huya.com/" target="_blank"></a></div>

        <div class="m-user">
            <div class="u-btn login" @click="$mslogin.open()" v-if="!login"></div>
            <span class="user-info" v-if="login">欢迎，{{ ua.uid }}<span class="logout" @click="logout">【退出】</span></span>
        </div>

        <div class="main-title"></div>
        <div class="u-btn apply" id="J-apply" @click="role_handle"></div>

        <div class="sponsor"></div>     
    </div>
</template>

<style scoped>
.m-head{
    position: relative;
    padding-top: 590px;
    height: 1055px;
    box-sizing: border-box;
}

.logo {
    position: absolute;
    left: 30px;
    top: 60px;
    width: 101px;
    height: 80px;
    background-image: url(../assets/images/logo.png);
    z-index: 10;
}

.logo a {
    display: block;
    width: 100%;
    height: 100%;
}

.u-web {
    position: absolute;
    left: 150px;
    top: 80px;
    width: 132px;
    height: 41px;
    background-image: url(../assets/images/logo-huya.png);
    z-index: 10;
}

.u-web a {
    display: block;
    width: 100%;
    height: 100%;
}

.m-user{
    position: absolute;
    right: 30px;
    top: 60px;
    height: 41px;
    z-index: 10;  
}

.m-user .u-btn.login{
    width: 164px;
    height: 54px;
    background-image: url(../assets/images/btn-login.png);
}

.user-info{
    font-size: 16px;
    color: #fff;
}

.user-info .logout{
    cursor: pointer;
}

.main-title{
    width: 912px;
    height: 268px;
    margin: 0 auto 0;
    background-image: url(../assets/images/main-title.png);
}

.u-btn.apply {
    width: 225px;
    height: 49px;
    margin: 45px auto;
    background-image: url(../assets/images/btn-apply.png);
}

.sponsor{
    width: 675px;
    height: 36px;
    margin: 40px auto;
    background-image: url(../assets/images/sponsor.png);
}
</style>

<script>
export default {
    data (){
        return {
            status : 1,
        }
    },
    props :{
        ua : {
            default : () => {},
        },
        login : {
            default : 0,
        }          
    },
    methods :{
        logout (){
            //console.log(this.$ajax_url_map.logout);
            this.$axios.get(this.$ajax_url_map.logout)
            .then(res => {
                window.location.reload();
            })
            .catch(err=>{
                window.location.reload();
            });
        },
        role_handle (){

            if(!this.login)return this.$mslogin.open();

            var role = this.ua.role,
                status = this.ua.state;

            if(role == 1){
                //队长
                //队员准备确认
                this.$axios.get(this.$ajax_url_map.players)
                .then(res => {
                    if(res.data.code == this.$ajax_code.success){
                        this.$list_modal({ 
                            member_data : res.data.data.players,
                            code : res.data.data.code,
                            tid : res.data.data.teamId,
                            zid : res.data.data.players[0].zid,
                        });
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });

            }
            else if(role == 2 && status == true){
                //队员
                //队员准备确认
                this.$axios.get(this.$ajax_url_map.players)
                .then(res => {
                    if(res.data.code == this.$ajax_code.success){
                        this.$list_modal({ 
                            member_data : res.data.data.players,
                            code : res.data.data.code,
                            tid : res.data.data.teamId,
                            zid : res.data.data.players[0].zid,
                        });
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });       
            }
            else{
                this.$entrance({
                    ua : this.ua,
                })
            }            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/head.vue